module.exports = __webpack_public_path__ + "img/australia.d9419c31.svg";